import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Card, Col } from "react-bootstrap";
import { setCategoryTitle } from "@/utils/constants/redux/sets";
import { URLS } from "@/utils/constants";
export const CategoryCard = ({ id, name, imageUrl }) => {
    const navigate = useNavigate();
    const redirect = (url, categoryTitle) => {
        setCategoryTitle(categoryTitle);
        navigate(url);
    };
    return (_jsx(Col, { children: _jsxs(Card, { onClick: () => redirect(URLS.store, name), className: "categories-card", children: [_jsx(Card.Img, { variant: "top", src: imageUrl, className: "w-60 mx-auto" }), _jsx(Card.Body, { className: "text-center", children: _jsx(Card.Title, { style: { fontWeight: "bold", fontSize: "2rem" }, children: name }) })] }, id) }, id));
};
